<template>
  <div class="salesGraph">
    <div class="salesGraph__selection-wrapper">
      <div class="salesGraph__selection-wrapper-left">
        <strong><Skeleton width="200px" height="50px" /></strong>
        <strong class="ml-10"><Skeleton width="200px" height="50px" /></strong>
      </div>
      <div class="salesGraph__selection-wrapper-right">
        <span><Skeleton width="100px" height="18px" /></span>
        <span class="ml-4"><Skeleton width="18px" height="18px" /></span>
      </div>
    </div>
    <div class="salesGraph__chart-wrapper mt-10 mb-20">
      <Skeleton width="100%" height="300px" />
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'SalesSkeleton',
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
.salesGraph {
  display: flex;
  flex-direction: column;
  padding-top: 18px;
  &__selection-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      display: flex;
      flex-direction: row;
    }
    &-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      .text {
        font-size: 13px;
        line-height: 1.85;
        font-weight: normal;
        text-align: left;
        color: #1f1f1f;
        &-bold {
          font-weight: bold;
          text-align: right;
          margin-left: 5px;
        }
      }
    }
  }
  &__chart-wrapper {
    width: 100%;
    height: 284px;
    &.loading {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
